var _path, _g, _g2, _path2, _g3, _g4, _path3, _g5, _g6, _circle, _g7, _path4, _g8, _g9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 326,
    viewBox: "0 0 152 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 110.326H151.5",
    stroke: "url(#paint0_linear_0_388)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 109.826,
    r: 16,
    fill: "#4A4085"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_0_388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 109.826,
    r: 10,
    fill: "#6C67A0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 311.326L151 322.826",
    stroke: "url(#paint1_linear_0_388)",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_0_388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 309.826,
    r: 16,
    fill: "#4A4085"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_0_388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 309.826,
    r: 10,
    fill: "#6C67A0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 19.3262L150.5 1.82617",
    stroke: "url(#paint2_linear_0_388)",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_0_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 16L139.5 3.5",
    stroke: "url(#paint3_linear_0_388)",
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_0_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 35C24.8366 35 32 27.8366 32 19C32 10.1634 24.8366 3 16 3C7.16344 3 0 10.1634 0 19C0 27.8366 7.16344 35 16 35Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 35C24.8366 35 32 27.8366 32 19C32 10.1634 24.8366 3 16 3C7.16344 3 0 10.1634 0 19C0 27.8366 7.16344 35 16 35Z",
    fill: "url(#paint4_linear_0_388)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 19C31.4 27.5052 24.5052 34.4 16 34.4C7.49481 34.4 0.6 27.5052 0.6 19C0.6 10.4948 7.49481 3.6 16 3.6C24.5052 3.6 31.4 10.4948 31.4 19Z",
    stroke: "url(#paint5_linear_0_388)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 7,
    fill: "url(#paint6_linear_0_388)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bi_0_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29C21.5228 29 26 24.5228 26 19C26 13.4772 21.5228 9 16 9C10.4772 9 6 13.4772 6 19C6 24.5228 10.4772 29 16 29Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 214.826H151.5",
    stroke: "url(#paint7_linear_0_388)",
    strokeWidth: 2
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_0_388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 212.826,
    r: 16,
    fill: "#4A4085"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_0_388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 212.826,
    r: 10,
    fill: "#6C67A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_388",
    x: 15,
    y: 73.8262,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_0_388",
    x: 21,
    y: 79.8262,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_0_388",
    x: -10,
    y: 273.826,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_0_388",
    x: -4,
    y: 279.826,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_0_388",
    x: 51.3578,
    y: 1.51019,
    width: 89.2844,
    height: 16.4796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_0_388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_0_388",
    x: -24,
    y: -21,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bi_0_388",
    x: 2,
    y: 5,
    width: 28,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_388"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_0_388",
    x: 18,
    y: 176.826,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_0_388",
    x: 24,
    y: 182.826,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_388"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_388",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_388",
    x1: 138.912,
    y1: 103.642,
    x2: 27.8243,
    y2: 132.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383167",
    stopOpacity: 0.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_388",
    x1: 134.216,
    y1: 234.46,
    x2: -23.4283,
    y2: 239.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383167",
    stopOpacity: 0.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_388",
    x1: 132.686,
    y1: -115.145,
    x2: -34.7142,
    y2: -111.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383167",
    stopOpacity: 0.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_388",
    x1: 140.344,
    y1: 16.5904,
    x2: 139.638,
    y2: 0.11709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EC49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A83F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_388",
    x1: 1.33333,
    y1: 9.4,
    x2: 36.216,
    y2: 14.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_388",
    x1: 1,
    y1: 4.45455,
    x2: 32,
    y2: 4.45455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_388",
    x1: 23.1357,
    y1: 26.6612,
    x2: 18.0763,
    y2: 9.68516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EC49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A83F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_388",
    x1: 138.912,
    y1: 208.142,
    x2: 27.8243,
    y2: 236.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383167",
    stopOpacity: 0.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSide);
export default __webpack_public_path__ + "static/media/RobotSide.ba5f9f61ca10f8738b5c77b23dd119ed.svg";
export { ForwardRef as ReactComponent };